import {
  GETTING_ALL_META_DATA_FAILED,
  UPDATING_SETTINGS_META_DATA_FAILED
} from 'store/settings/actions';

import { dismissButton } from 'helpers/error/buttonBuilders';
import { SETTINGS } from 'views/UserMessaging/userMessageDomains';

const settings = {
  [SETTINGS]: {
    [GETTING_ALL_META_DATA_FAILED]: {
      userMessage: {
        instructions: 'Failed getting settings',
        buttons: [dismissButton()]
      }
    },
    [UPDATING_SETTINGS_META_DATA_FAILED]: {
      userMessage: {
        instructions: 'Failed updating the settings',
        buttons: [dismissButton()]
      }
    }
  }
};

export default { ...settings };
